export const SESSION_EXPIRED_MESSAGE = "Session expired. Please login again.";

/** Refresh responses with these statuses mean the refresh token itself is dead. */
export const REFRESH_TOKEN_REJECTED_STATUSES: readonly number[] = [
  400, 401, 403,
];

export const IDLE_ACTIVITY_EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "scroll",
  "touchstart",
  "click",
  "wheel",
] as const;
